<div class="d-flex flex-row justify-content-end">
  <div class="order-label">{{'group_details.search_bar.sort_by' | translate}}</div>
  <div class="order-btn date" [ngClass]="{'active': hasOrderBy('latest')}" (click)="onOrderBy('latest')">{{'dashboard.order_bar.new' | translate}}</div>
  <div class="order-btn reach" [ngClass]="{'active': hasOrderBy('reach')}" (click)="onOrderBy('reach')">{{'dashboard.order_bar.reach' | translate}}</div>
  <div class="order-btn engagement" [ngClass]="{'active': hasOrderBy('engagement')}" (click)="onOrderBy('engagement')">{{'dashboard.order_bar.engagement' | translate}}</div>
  <div class="order-btn impact" [ngClass]="{'active': hasOrderBy('impact')}" (click)="onOrderBy('impact')">{{'dashboard.order_bar.impact' | translate}}</div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer-home/influencer-home-order-bar/influencer-home-order-bar.component.html